import { Controller } from '@hotwired/stimulus'
import { useClickOutside } from 'stimulus-use'

export default class extends Controller {
  static targets = ['dateChip', 'dateInputContainer', 'dateInput', 'resetButton']

  connect() {
    useClickOutside(this, { element: this.dateInputContainerTarget })
  }

  clickOutside(event) {
    const flatpicker = document.getElementsByClassName('flatpickr-calendar')
    const elemClickedIsFlatpicker = flatpicker[0].contains(event.target)

    if (!elemClickedIsFlatpicker) {
      this.hideInput()
    } else {
      event.preventDefault()
    }
  }

  displayInput(event) {
    if (this.resetButtonClicked(event)) return

    this.dateInputContainerTarget.classList.remove('hidden')
    this.dateChipTarget.classList.add('hidden')

    this.sendEventToOpenDatePicker()
  }

  hideInput() {
    this.dateInputContainerTarget.classList.add('hidden')
    this.dateChipTarget.classList.remove('hidden')
  }

  clearDate() {
    this.dateInputTarget.value = ''
    this.dateInputTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }

  resetButtonClicked(event) {
    if (!this.hasResetButtonTarget) return
    return this.resetButtonTarget.contains(event.target)
  }

  sendEventToOpenDatePicker() {
    window.dispatchEvent(new CustomEvent('openDatepicker'))
  }
}
